import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Stack, Typography } from '@mui/material';

import ThreatGeoChip from 'components/ThreatGeoChip';
import ThreatRegionCard from './ThreatRegionCard';

const ThreatRegions = ({ threatRegions }) => (
  <Stack rowGap={3}>
    <Stack direction="row" justifyContent="space-between">
      <Typography color="#FFF" fontSize={24} data-testid="threat_geo-top_attack_origins">
        Top {threatRegions.length} Attack Origins
      </Typography>
      <Stack direction="row" alignItems="center" spacing={2.5}>
        {['low', 'medium', 'high', 'critical'].map((severity) => (
          <ThreatGeoChip key={severity} fontSize={14} severity={severity} text={severity} />
        ))}
      </Stack>
    </Stack>
    <Grid container spacing={2} columns={60}>
      {threatRegions.map((threatRegion, index) => (
        <ThreatRegionCard key={threatRegion.country} region={threatRegion} index={index + 1} />
      ))}
    </Grid>
  </Stack>
);

ThreatRegions.propTypes = {
  threatRegions: PropTypes.array.isRequired,
};

export default ThreatRegions;
